"use strict";

new Vue({
  mixins: [main],
  data: function data() {
    return {
      store: this.getUrlVal('store') ? this.getUrlVal('store') : '1',
      storeItems: [],
      storeLoading: true,
      campaignItems: [],
      campaignNumber: 6,
      campaignLoading: true,
      arrivalItems: [],
      arrivalNumber: 10,
      arrivalLoading: true,
      searchStoreItems: [],
      searchStore: this.getUrlVal('store') ? this.getUrlVal('store') : '1'
    };
  },
  computed: {
    searchStoreText: function searchStoreText() {
      var _this = this;

      var text = 'すべて';
      this.searchStoreItems.some(function (store) {
        if (store.value === _this.searchStore) {
          text = store.text;
          return true;
        }
      });
      return text;
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    axios.get(apiUrl + '/api/get_store', {
      params: {
        id: this.store
      }
    }).then(function (response) {
      _this2.storeItems = response.data.items.map(function (item) {
        return {
          name: item.name,
          tel: item.navidial,
          openingHour: item.opening_hour,
          map: 'https://www.google.com/maps/search/?api=1&query=' + item.address,
          url: '/store/' + item.id + '/'
        };
      });
      _this2.storeLoading = false;
    });
    axios.get(apiUrl + '/api/get_news', {
      params: {
        store: this.store,
        category: '2',
        number: this.campaignNumber
      }
    }).then(function (response) {
      _this2.campaignItems = response.data.items.map(function (item) {
        return {
          title: item.title,
          category: {
            id: item.category.id,
            name: item.category.name,
            url: '/news/?category=' + item.category.id
          },
          date: item.date,
          store: item.store.map(function (store) {
            return {
              name: store.name,
              url: '/news/?store=' + store.id
            };
          }),
          url: '/news/' + item.id + '/'
        };
      });
      _this2.campaignLoading = false;
    });
    axios.get(apiUrl + '/api/get_arrival', {
      params: {
        store: this.store,
        number: this.arrivalNumber
      }
    }).then(function (response) {
      _this2.arrivalItems = response.data.items.map(function (item) {
        return {
          name: item.title,
          img: item.thumbnail ? olineImgUrl + '/' + item.thumbnail : templateDirectoryUri + '/img/no_image_arrival_s.jpg',
          url: '/arrival/' + item.id + '/',
          r18Flag: item.r18_flag
        };
      });
      _this2.arrivalLoading = false;

      _this2.$nextTick(function () {
        initSlick('list');
      });
    });
    axios.get(apiUrl + '/api/get_store').then(function (response) {
      var items = response.data.items.filter(function (store) {
        return exStores.indexOf(store.name) === -1;
      }).sort(function (storeA, storeB) {
        return storeA.area - storeB.area;
      }).map(function (store) {
        return {
          text: store.name.replace(/^らしんばん/, ''),
          value: String(store.id)
        };
      });
      _this2.searchStoreItems = items;
    });
  }
});